import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-compass",
  "use": "icon-compass-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-compass\"><path d=\"M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm6.417 4.583l-4.584 8.25-8.25 4.584 4.584-8.25 8.25-4.584zM12 11.083a.917.917 0 100 1.834.917.917 0 000-1.834z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol